export default __webpack_public_path__ + "static/media/generic-nterior2.e6691a98.png";